import React, { useState } from "react";
import { useAppContext } from "../contexts/AppContext";

const ContactForm = () => {
  const { addContact } = useAppContext();
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    addContact({ name });
    setName("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Contact Name"
        required
      />
      <button type="submit">Add Contact</button>
    </form>
  );
};

export default ContactForm;
